import { Content } from "antd/lib/layout/layout";
import { useEffect, useState } from "react";
import { GetMetabaseUrlApi } from "../../api/metabase/GetMetabaseUrlApi";
import { useSelector } from "react-redux";
import PageLoader from "../../components/sub/PageLoader";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import { Button, Tooltip } from "antd";
import { ReloadOutlined, WarningOutlined } from "@ant-design/icons";

function MetabaseDashboard() {
  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState("");
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const userState = useSelector((state) => state.userState.value);

  useEffect(() => {
    getUrl();
  }, []);

  async function getUrl() {
    setLoading(true);
    const apiResponse = await GetMetabaseUrlApi(
      positionState?.id,
      perfCycleState?.id
    );
    if (apiResponse.success) {
      setUrl(apiResponse.data);
    }
    setLoading(false);
  }

  const left = <div className="pri-font text-lg">Dashboard</div>;

  const right = (
    <>
      <Tooltip title={"Settings"}>
        <Button onClick={() => getUrl()} className="mr-3">
          <ReloadOutlined />
        </Button>
      </Tooltip>
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
            padding: "24px",
          }}
          className="custom-scroll"
        >
          <div className="mb-6">
            <div className="text-2xl pri-font">Hi, {userState?.firstName}!</div>
          </div>
          {loading ? (
            <PageLoader />
          ) : url ? (
            <iframe
              title="Metabase Dashboard"
              src={url}
              style={{
                width: "100%",
                height: "calc(100vh - 170px)",
                border: "none",
                borderRadius: "8px",
                backgroundColor: "#fff",
              }}
              allowTransparency
            />
          ) : (
            <div className="flex justify-center items-center w-full h-full">
              <div className="text-center">
                <div className="text-3xl text-gray-400">
                  <WarningOutlined />
                </div>
                <div className="text-xl pri-font text-gray-400">
                  No dashboard available for this position.
                </div>
              </div>
            </div>
          )}
        </div>
      </Content>
    </>
  );
}

export default MetabaseDashboard;
